<template>

    <div>

        <v-layout row>

            <v-dialog class="dialog" v-model="dialog" persistent max-width="500px">

                <template  v-slot:activator="{}">

                    <v-btn
                        v-if="!!hibajelentesVisible"
                        color="errorReportButtonColor"
                        style="color: var(--v-errorReportButtonTextColor-base);"
                        dark
                        small
                        class="button"
                        @click="getAnnounceObject()"
                    >

                        Hibajelentés küldése

                    </v-btn>

                </template>

                <v-card>

                    <v-card-title class="headline">

                        Hibajelentés küldése

                    </v-card-title>

                    <v-card-text>

                        <v-container grid-list-md>

                            <v-layout wrap>

                                <v-flex md12>

                                    <v-text-field v-model="announce.email"
                                                  label="Üzletkötő email címe"/>

                                </v-flex>

                                <v-flex md12>

                                    <v-text-field v-model="announce.telefon"
                                                  label="Üzletkötő telefonszáma"/>

                                </v-flex>

                                <v-flex md12>

                                    <v-text-field v-model="announce.bejelentes"
                                                  label="A probléma leírása"
                                                  hint="Legalább 20 karakter"
                                                  persistent-hint
                                    />

                                </v-flex>

                            </v-layout>

                        </v-container>

                    </v-card-text>

                    <v-card-actions>

                        <v-btn class="button" text color="secondary" @click.native="dialog = false">Mégse</v-btn>

                        <v-btn
                            class="button"
                            text
                            color="secondary"
                            :disabled="disabled"
                            @click.native="sendAnnounce()"
                        >
                            Küldés
                        </v-btn>

                    </v-card-actions>

                </v-card>

            </v-dialog>

        </v-layout>

        <v-snackbar
            class="snackbar"
            :bottom="true"
            :right="true"
            v-model="hibajelentesResponseAlert"
            :color="color"
            :multi-line="multiline" :timeout="timeout"
        >
            {{ response.message }}

            <v-btn class="button" color="white" text @click="hibajelentesResponseAlert = false">

                Rendben

            </v-btn>

        </v-snackbar>

    </div>

</template>

<script>

import axios from 'axios';
import EventBus from '../../modules/EventBus';
import {HUNDEALER,HUNBENEFIT} from '../../modules/Ceg';

export default {
    data: () => ({
        dialog: false,
        announce: {
            cegnev: '',
            tarifainfo: '',
            uzletkotonev: '',
            telefon: '',
            email: '',
            bejelentes: '',
        },
        color: '',
        multiline: true,
        hibajelentesVisible: true,
        timeout: 5000,
        response: {
            success: true,
            message: 'Hibajelentés elküldve',
        },
        hibajelentesResponseAlert: false,
    }),

    beforeCreate() {
        EventBus.$on('hide-hibajelentes-btn', () => {
            this.hibajelentesVisible = false;
        });

        EventBus.$on('show-hibajelentes-btn', () => {
            this.hibajelentesVisible = true;
        });
    },
    watch: {
      companyId(val) {
        if (val === HUNDEALER || val === HUNBENEFIT) {
          this.hibajelentesVisible = false;
        }
      },

      balesetCompanyId(val) {
        console.log(val);
        if (val === HUNDEALER || val === HUNBENEFIT) {
          this.hibajelentesVisible = false;
        }
      }
    },
    computed: {
        disabled() {
            return !this.announce.bejelentes || this.announce.bejelentes.length < 20;
        },
        companyId() {
          return this.$store.getters.companyId;
        },
        balesetCompanyId() {
          return this.$store.getters.getBroker.ceg;
        }
    },
    methods: {
        sendAnnounce() {
            const announce = { ...this.announce };
            const data = {
                userAgent: navigator.userAgent,
                tarifaData: this.$store.getters.tarifaData,
                vehicle: this.$store.getters.gepjarmu,
                uzembentarto: this.$store.getters.uzembentarto,
                tulajdonos: this.$store.getters.tulajdonos,
                finanszirozo: this.$store.getters.finanszirozo,
            };
            axios.post('/api/announce/announceError', {
                announce,
                data,
            })
                .then((response) => {
                    this.color = response.data.success ? 'success' : 'error';
                    this.hibajelentesResponseAlert = true;
                    this.dialog = false;
                })
                .catch((err) => {
                    this.color = err.data.success ? 'success' : 'error';
                    this.hibajelentesResponseAlert = true;
                    this.dialog = false;
                });
        },

        getAnnounceObject() {
            this.dialog = true;
            this.announce = this.$store.getters.announce;
            // eslint-disable-next-line prefer-const
            let { tarifaId, id } = this.$store.getters;
            if (!tarifaId) {
                tarifaId = this.$store.getters.tarifaData.tarifa_id;
            }
            if (id) {
                this.announce.tarifainfo = `${id}/${tarifaId}`;
            }
            this.announce.cegnev = this.$store.getters.getBroker.cegname;
            this.announce.uzletkotonev = this.$store.getters.getBroker.username;
            this.announce.email = this.$store.getters.getBroker.useremail;
            this.announce.telefon = this.$store.getters.getBroker.userphone;
        },
    },
};
</script>
<style scoped>
.snackbar {
    font-size: 20px;
}

.dialog {
    z-index: 200;
}
</style>
